<template>
    <div class="basic">
        <div class="manage-title"><em class="txt">基本信息</em></div>
        <div class="infoBox margin-top-20">
            <div class="item flex">
                <p class="tit">达人姓名</p>
                <p class="txt">{{name}}</p>
            </div>
            <div class="item flex">
              <p class="tit">手机号码</p>
              <p class="txt">{{phone}}</p>
            </div>
            <div class="item flex">
              <p class="tit">达人昵称</p>
              <p class="txt">{{nickname}}</p>
            </div>
            <div class="item flex">
                <p class="tit">达人性别</p>
                <p class="txt" v-if="sex === '0'">女</p>
                <p class="txt" v-if="sex === '1'">男</p>
            </div>
            <div class="item flex">
                <p class="tit">达人年龄</p>
                <p class="txt">{{birthday}}</p>
            </div>
            <div class="item flex">
                <p class="tit">达人职业</p>
                <p class="txt">{{occupation_name}}</p>
            </div>
            <div class="item flex">
              <p class="tit">个人简介</p>
              <p class="txt">{{content}}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'InfoBasic',
  props: {
      name: String,
      phone: String,
      nickname: String,
      sex: String,
      birthday: Number,
      occupation_name: String,
      content: String
  }
}
</script>
<style scoped></style>
